<template>
  <div v-bind:class="['library-carousel', addClass]">
    <ul class="library-carousel-list">
      <library-card v-bind:movie="movie" v-for="(movie, key) in movies" :key="key"></library-card>
    </ul>
  </div>
</template>

<script>
import LibraryCard from '../common/LibraryCard'

export default {
  name: 'carousel',
  components: {
    LibraryCard
  },
  props: ['movies', 'addClass']
}
</script>